<template>
  <section>
    <div class="mb-2">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="headline" v-text="content.title"></div>
          <div
            class="subtitle-1 grey--text text--darken-2"
            v-text="content.subtitle"
          ></div>
        </div>
        <template v-if="content.headerButton != null">
          <div class="flex-shrink-1">
            <v-btn text :color="$buttonColor" @click="more">
              SEE MORE
              <v-icon right small>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </div>
    <v-slide-group :show-arrows="true">
      <v-slide-item v-for="(item, idx) of content.body" :key="`cat_${idx}`">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-sheet
                v-on="on"
                class="text-center card-growable pt-4 hoverable"
                :min-height="iconHeight + 48"
                :width="180"
                @click="navigate(item)"
              >
                <v-avatar
                  :class="[hover ? 'primary lighten-4' : 'grey lighten-3']"
                  class="pa-4"
                  :size="iconHeight"
                >
                  <img
                    :style="{
                      maxHeight: iconHeight - 32 + 'px',
                      width: 'auto',
                      maxWidth: iconHeight - 32 + 'px',
                      borderRadius: '0px',
                    }"
                    :src="item.image"
                    alt
                  />
                </v-avatar>

                <div
                  :class="{ 'primary--text': hover }"
                  class="font-weight-bold subtitle-1 text-center mt-3 text-overflow"
                  v-text="item.title"
                ></div>
              </v-sheet>
            </v-hover>
          </template>

          <span v-text="item.title"></span>
        </v-tooltip>
        <!-- <v-card
          :color="active ? 'primary' : 'white'"
          class="ma-4"
          height="300"
          width="200"
          @click="toggle"
        >
          <v-row class="fill-height" align="center" justify="center">
            <v-scale-transition>
              <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'"></v-icon>
            </v-scale-transition>
          </v-row>
        </v-card>-->
      </v-slide-item>
    </v-slide-group>
    <template v-if="content.footerButton != null">
      <div class="mt-3">
        <v-btn :color="$buttonColor">
          SEE MORE
          <v-icon right small>far fa-chevron-right</v-icon>
        </v-btn>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: "category_horizontal_listview",
  props: ["content"],
  data: () => ({
    selected: null,
    iconHeight: 72,
    categories: [],
  }),
  mounted() {
    // this.createCourseRequest()
    //     .then(resp => {
    //       if (resp.data.status) {
    //         let allCategory = resp.data.result.elements
    //         for (let category of allCategory) {
    //           this.categories.push(category);
    //         }
    //       } else {
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //     });
  },
  methods: {
    createCourseRequest() {
      let url = `${this.$store.state.api}`;
      url += `/home/category`;

      return this.$http.get(url);
    },
    navigate(item) {
      this.$router.push({
        name: "course",
        query: {
          category: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
        },
      });
    },
    more() {
      const qs = this.$utility.queryStringToJson(
        this.content.headerButton.queries
      );
      this.$router.push({
        name: "categories",
        query: qs,
      });
    },
  },
};
</script>